export default {
  'COUNTRY OVERVIEW REPORT (CORE)': 'core_report',
  'MAP DATA': 'map_data',
  'POTENTIAL M&A OPPORTUNITIES': 'ma_opportunities_data',
  'EXPLORATION AND APPRAISAL WELL TRACKER': 'offshore_well_tracker_data',
  'LICENSING ROUND & DRO TRACKER': 'licensing_dro_data',
  'GIS DATA': 'gis_data',
};
